<template>
  <div class="chatItem">
    <div class="userInfo">
      <img :src="chatItem.avatar || defaultAvatar" alt="用户头像" />
    </div>
    <div class="chatWrap">
      <div class="nickname">{{ chatItem.nickname || '祝福使者' }}</div>
      <div class="blessingMsg">
        <span class="blessingTag">祝福</span>
        <span class="heartIcon">❤️</span>
        {{ chatItem.chatContext || '祝你幸福快乐！' }}
        <span class="flowerIcon">🌸</span>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultAvatar } from "@/utils/constant";
export default {
  name: "ChatWish",
  props: {
    chatItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultAvatar: defaultAvatar
    }
  }
}
</script>

<style lang="less" scoped>
.chatItem {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  animation: fadeIn 0.5s ease;

  .userInfo {
    margin-left: 25px;
    img {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      border: 2px solid #FF2442;
    }
  }

  .chatWrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-left: 6px;

    .nickname {
      color: #FF2442;
      font-size: 12px;
      margin-bottom: 3px;
      background-color: rgba(255, 36, 66, 0.1);
      padding: 3px 6px;
      border-radius: 3px;
      font-weight: bold;
    }

    .blessingMsg {
      font-size: 13px;
      font-weight: 500;
      line-height: 17px;
      color: #333;
      overflow-wrap: break-word;
      background: linear-gradient(to right, #fff0f6, #ffeef5);
      padding: 8px 12px;
      border-radius: 7px;
      max-width: 280px;
      position: relative;
      border: 1px solid #ffc0cb;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

      .blessingTag {
        display: inline-block;
        background-color: #FF2442;
        color: white;
        font-size: 10px;
        padding: 1px 4px;
        border-radius: 3px;
        margin-right: 5px;
        transform: translateY(-1px);
      }

      .heartIcon {
        margin-right: 5px;
        color: #FF2442;
      }

      .flowerIcon {
        margin-left: 5px;
        color: #FF2442;
      }

      &::before {
        content: '';
        position: absolute;
        left: -8px;
        top: 5px;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-right-color: #fff0f6;
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>